import { render } from "./ManageProject.vue?vue&type=template&id=8b0ea994&scoped=true"
import script from "./ManageProject.vue?vue&type=script&lang=js"
export * from "./ManageProject.vue?vue&type=script&lang=js"

import "./ManageProject.vue?vue&type=style&index=0&id=8b0ea994&scoped=true&lang=css"
import "./ManageProject.vue?vue&type=style&index=1&id=8b0ea994&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b0ea994"]])

export default __exports__